import { Label, Loader } from "semantic-ui-react";

import { AppointmentStatusCell, DATE_FORMATS_FNS } from "components";
import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import "components/NavBarSearchAppointments/components/SearchDropdown/SearchDropdown.scss";
import { SEARCH_OPTION_TYPE } from "components/NavBarSearchAppointments/util";
import { formatDate } from "utils/dateHelperFunctions";
import { getDmsGroupLabel } from "utils/dms";

import type { AppointmentSearchOption } from "components/NavBarSearchAppointments/util";

type SearchResultRowProps = {
  selectedId: string | null;
  isImportAppointmentPending: boolean;
  item: AppointmentSearchOption;
  handleOnClick: (id: string, type: SEARCH_OPTION_TYPE) => void;
};

export const SearchResultRow = ({ item, handleOnClick, isImportAppointmentPending, selectedId }: SearchResultRowProps) => {
  const { selectedLocation } = useSelectedLocation();

  const date = item.due_in ? `${formatDate(item.due_in, DATE_FORMATS_FNS.dateMonthYear)} | ` : "";
  const woNr = item.wo_nr ? `${item.wo_nr} | ` : "";
  const regNr = item.reg_number ? `${item.reg_number} | ` : "";
  const showLoader = isImportAppointmentPending && selectedId === item.id;
  const dmsGroupLabel = getDmsGroupLabel(selectedLocation?.dms_id);

  return (
    <div key={item.id} className="search-list" onClick={() => handleOnClick(item.type === SEARCH_OPTION_TYPE.Claire ? item.id : item.dms_nr, item.type)}>
      {dmsGroupLabel && <Label>{item.type === SEARCH_OPTION_TYPE.Claire ? "Claire" : dmsGroupLabel}</Label>}

      <p className="search-title">{`${item.car_make} ${item.car_model}`.trim()}</p>

      <div className="search-row">
        <p>{`${date}${woNr}${regNr} ${item.dealer_location?.name || ""}`}</p>
        {showLoader ? (
          <Loader active={isImportAppointmentPending} inline size="small" />
        ) : (
          <AppointmentStatusCell
            value={{
              id: item.appointment_status_identifier,
              customcom_status: item.customcom_status,
              car_check_paused_at: item.car_check_paused_at,
              car_out_of_shop: item.car_out_of_shop
            }}
            statuses={selectedLocation?.statuses}
          />
        )}
      </div>
    </div>
  );
};
